// Smooth open/close for product accordions.
// Native <details> toggles content visibility in one frame, so CSS height
// transitions never run. The grid-fr trick also stutters on some browsers.
// Instead we drive an explicit pixel-height transition from JS: animate
// 0 <-> scrollHeight, then settle to height:auto so nested content can reflow.
(function () {
  const DURATION = 300; // keep in sync with the CSS transition below

  function open(details, content) {
    details.setAttribute('open', '');
    content.style.height = '0px';
    void content.offsetHeight; // reflow: lock in the 0 start
    content.style.height = content.scrollHeight + 'px';

    const onEnd = (e) => {
      if (e.propertyName !== 'height' || e.target !== content) return;
      content.removeEventListener('transitionend', onEnd);
      content.style.height = 'auto'; // let it grow/shrink freely once open
      delete details.dataset.animating;
    };
    content.addEventListener('transitionend', onEnd);
  }

  function close(details, content) {
    // From auto -> fixed px so the transition has a start value, then -> 0.
    content.style.height = content.scrollHeight + 'px';
    void content.offsetHeight;
    content.style.height = '0px';

    const onEnd = (e) => {
      if (e.propertyName !== 'height' || e.target !== content) return;
      content.removeEventListener('transitionend', onEnd);
      details.removeAttribute('open');
      content.style.height = '';
      delete details.dataset.animating;
    };
    content.addEventListener('transitionend', onEnd);
  }

  function init(root) {
    const items = (root || document).querySelectorAll('.product__accordion details');
    items.forEach((details) => {
      if (details.dataset.animBound) return;
      details.dataset.animBound = '1';

      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.dataset.animating === '1') return;
        details.dataset.animating = '1';

        if (details.open) {
          close(details, content);
        } else {
          const group = details.closest('[data-accordion-enabled]');
          if (group) {
            const siblings = group.querySelectorAll('[data-collapsible] > details[open]');
            siblings.forEach((sib) => {
              if (sib === details || sib.dataset.animating === '1') return;
              sib.dataset.animating = '1';
              const sibContent = sib.querySelector('.accordion__content');
              if (sibContent) close(sib, sibContent);
            });
          }
          open(details, content);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
